import axios from 'axios';
import { XPPromo } from './types';
import { getToken } from '../../../utils/auth';

const requestItvUrl = import.meta.env.VITE_ITV_URL;
const requestXPUrl = `${import.meta.env.VITE_XP_URL}/p2e/players/@me/quests`;
const xpNamespace = import.meta.env.VITE_XP_NAMESPACE;

export const getXPToken = async (): Promise<string> => {
  const token = getToken();

  const config = {
    headers: {
      authorization: `Bearer ${token}`,
    },
  };

  const result = await axios.get(`${requestItvUrl}/api/loyalty`, config);

  return result?.data?.token;
};

export const getXPPromos = async (token: string): Promise<XPPromo[]> => {
  const config = {
    headers: {
      accept: 'application/json',
      'scrimmage-namespace': xpNamespace,
      authorization: `Bearer ${token}`,
    },
  };

  const result = await axios.get(`${requestXPUrl}`, config);

  return result?.data;
};

const handleOptApi = async (questId: string | null | undefined, token: string, isClaim?: boolean): Promise<void> => {
  const config = {
    headers: {
      'scrimmage-namespace': xpNamespace,
      authorization: `Bearer ${token}`,
    },
  };

  await axios.post(`${requestXPUrl}/${questId}/${isClaim ? 'claim' : 'accept'}`, {}, config);
};

export const optInXPPromo = async (questId: string | null | undefined, token: string): Promise<void> =>
  await handleOptApi(questId, token);

export const claimXPPromo = async (questId: string | null | undefined, token: string): Promise<void> =>
  await handleOptApi(questId, token, true);
